import { createContext } from "react";

import { type TabsVariantsProps } from "./styles";

type TabsContextType = {
  lineLayoutId: string;
  variant: TabsVariantsProps["variant"];
};

export const TabsContext = createContext<TabsContextType>({
  lineLayoutId: "",
  variant: "buttons",
});
